import { render, staticRenderFns } from "./PageRender.vue?vue&type=template&id=ae4dc3bc"
import script from "./PageRender.vue?vue&type=script&lang=js"
export * from "./PageRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports